import React from 'react';
import doctorImage from '../Assets/doctor.png';
import skinTypeImage from '../Assets/skinType.png';
import preCareImage from '../Assets/pre-care.jpg';
import lipBlushImage from '../Assets/LipBlush.jpg';
import useSiteContent from '../hooks/useSiteContent';
import TreatmentPage from './TreatmentPage';

export default function LipBlushPage() {
  const { siteContent } = useSiteContent();

  return (
    <TreatmentPage
      pageContent={siteContent.lips}
      candidateImage={doctorImage}
      candidateAlt="Lip blush details"
      cautionImage={skinTypeImage}
      cautionAlt="Lip blush caution"
      beforeImage={preCareImage}
      beforeAlt="Before lip blush care"
      afterImage={lipBlushImage}
      afterAlt="After lip blush care"
      ctaTo="/pricing"
      ctaLabel={siteContent.common.pricing}
    />
  );
}
